import { render, staticRenderFns } from "./BackupStatusBadge.vue?vue&type=template&id=697f42b6&scoped=true&"
import script from "./BackupStatusBadge.vue?vue&type=script&lang=js&"
export * from "./BackupStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./BackupStatusBadge.vue?vue&type=style&index=0&id=697f42b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697f42b6",
  null
  
)

export default component.exports